import { Component } from '@angular/core';
import {RouterOutlet} from "@angular/router";
import {NgClass} from "@angular/common";
import {MenuComponent} from "../../component/menu/menu.component";

@Component({
  selector: 'app-restricted-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    NgClass,
    MenuComponent
  ],
  templateUrl: './restricted-layout.component.html',
  styleUrl: './restricted-layout.component.scss'
})
export class RestrictedLayoutComponent {
  menuCollapsed: boolean = false;
}
